import React from 'react'
import Text from 'react-text'
import ResourceRow from './resourceRow'
import './resourceTable.styl'

export default function ResourceTable ({kind, resources}) {
  return (
    <div className={`${kind} resource-table`}>
      <p><strong><Text id={kind} /></strong></p>
      <table>
        <thead>
          <tr>
            <th className="name"><Text id={`${kind}_product`} /></th>
            <th className="description"><Text id={`${kind}_description`} /></th>
            <th className="download"><Text link /></th>
          </tr>
        </thead>
        <tbody>{resources.map((id, key) => (<ResourceRow {...{key, id, kind}} />))}</tbody>
      </table>
    </div>
  )
}
